import { Currency, Price } from '@pancakeswap/swap-sdk-core'
import { formatPrice } from '@pancakeswap/utils/formatFractions'
import { useState } from 'react'
import { Loading } from '@pancakeswap/uikit'
import { ArrowRightLeftIcon } from 'lucide-react'

export function TradePrice({ price, loading }: { price?: Price<Currency, Currency>; loading?: boolean }) {
  const [showInverted, setShowInverted] = useState(false)

  const formattedPrice = showInverted ? formatPrice(price, 6) : formatPrice(price?.invert(), 6)
  const show = Boolean(price?.baseCurrency && price?.quoteCurrency)

  return (
    <>
      {show ? (
        <button
          type={'button'}
          onClick={() => setShowInverted(!showInverted)}
          className={'flex items-center text-sm text-muted-foreground gap-1 cursor-pointer'}
        >
          {`1 ${showInverted ? price?.baseCurrency?.symbol : price?.quoteCurrency?.symbol}`}
          &nbsp;=&nbsp;
          {`${formattedPrice} ${showInverted ? price?.quoteCurrency?.symbol : price?.baseCurrency?.symbol}`}
          {loading ? <Loading width="12px" height="12px" /> : <ArrowRightLeftIcon width={14} height={14} />}
        </button>
      ) : (
        ''
      )}
    </>
  )
}
